import React, { useState } from 'react'
import lang from 'lang'
import { ModalSmall } from '@/modules/base/components/modal'
import { CancelButton, ButtonIconSquare } from '@/modules/base/components/buttons'

import IconCheck from '@assets/images/icons/check.svg'
import { TextInput } from '@/modules/base/components/inputs'
import { makeStyles } from '@mui/styles'
import { CssHelper } from '@/modules/base/view/mixin/helpers_mixin'
import PropTypes from 'prop-types'
import { toast } from '@/modules/base/components/toast/toastConfig'

const useStyles = makeStyles((theme) => ({
  input: {
    margin: CssHelper.px(30, 0),
  },
}))

const TextPromptModal = (props) => {
  const classes = useStyles(props)

  const {
    title,
    subTitle,
    open = false,
    onSubmit,
    onClose,
    value,
    confirmButtonLabel,
    emptyErrorMessage,
    invalidCharacters,
    dataQsId,
  } = props

  const [_value, setValue] = useState(value)

  const close = (e) => {
    e.stopPropagation()
    onClose(e)
  }

  const onConfirmButton = (e) => {
    e.stopPropagation()
    e.preventDefault()
    submit(_value)
  }

  const submit = (v) => {
    if (!v && emptyErrorMessage) {
      return toast.showToast({ type: 'error', message: emptyErrorMessage })
    }
    onSubmit(v)
  }

  const buttons = [
    <CancelButton
      key='cancel'
      type='cancel'
      label={lang.cancelButtonLabel}
      onClick={close} />,
    <ButtonIconSquare
      key='confirm'
      customClass={classes.actionButton}
      type='submit'
      icon={IconCheck}
      label={confirmButtonLabel ?? lang.confirmButtonLabel}
      onClick={onConfirmButton} />,
  ]

  return (
    <ModalSmall
      title={title}
      subtitle={subTitle}
      actions={buttons}
      open={open}
      onClose={close}
      dataQsId={dataQsId}>
      <TextInput className={classes.input} autoFocus={true} useFormik={false} value={_value}
        invalidCharacters={invalidCharacters} onChange={setValue} onEnter={onConfirmButton} />
    </ModalSmall>
  )
}

TextPromptModal.propTypes = {
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  confirmButtonLabel: PropTypes.string,
  open: PropTypes.bool,
  value: PropTypes.string,
  emptyErrorMessage: PropTypes.string,
  invalidCharacters: PropTypes.array,
  dataQsId: PropTypes.string.isRequired,
}

export default TextPromptModal
